function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 20a10 10 0 0010-10H0a10 10 0 0010 10z",
  fill: "#f0f0f0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0A10 10 0 000 10h20A10 10 0 0010 0z",
  fill: "#c80e2e"
});

function SvgId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojYzgwZTJlO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMCwyMEExMCwxMCwwLDAsMCwyMCwxMEgwQTEwLDEwLDAsMCwwLDEwLDIwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLDBBMTAsMTAsMCwwLDAsMCwxMEgyMEExMCwxMCwwLDAsMCwxMCwwWiIvPjwvc3ZnPg==";
export { SvgId as ReactComponent };